import { LocalOperation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { removeFormElement, RemoveFormElementAction } from 'store/data/forms';
import { ActionPayload } from 'store/types';

export function useRemoveFormElement(): LocalOperation<
	(payload: ActionPayload<RemoveFormElementAction>) => void
> {
	const dispatch = useDispatch();

	function handler(payload: ActionPayload<RemoveFormElementAction>) {
		dispatch(removeFormElement(payload));
	}

	return handler;
}
